"use client";

import { ChangeEvent, ComponentPropsWithRef, forwardRef, useId, useMemo, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";
import { v4 as uuid } from "uuid";

import cn from "@/utils/cn";

export interface SwitchProps extends ComponentPropsWithRef<"input"> {
  name: string;
  values?: any[];
  labels: string[];
  field?: ControllerRenderProps;
  fieldState?: ControllerFieldState;
}

const SwitchBase = forwardRef<HTMLInputElement, SwitchProps>(({ name, labels, field, fieldState, values, ...rest }, ref) => {
  const defaultID = useId();
  return (
    <div className="bg-gray-7 w-fit mx-auto p-xxs rounded-full flex">
      {values?.map((value, index) => {
        return (
          <input
            key={`${name}-${value}`}
            {...rest}
            {...field}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              rest?.onChange?.(event as ChangeEvent<HTMLInputElement>);
              field?.onChange(event);
            }}
            value={value}
            id={`${defaultID}-${name}-${value}`}
            ref={field?.ref ?? ref}
            name={name}
            aria-label={labels?.[index] ?? value}
            type="radio"
            className="hidden"
            checked={rest?.value === value}
          />
        );
      })}
      {labels?.map((label, index) => {
        return (
          <label
            className={`${rest?.value === values![index] ? "bg-gold text-black" : "text-gray-70"} text-nowrap transition-all cursor-pointer p-xs rounded-full text-s block`}
            htmlFor={`${defaultID}-${name}-${values![index]}`}
            key={label}
          >
            {label}
          </label>
        );
      })}
    </div>
  );
});
SwitchBase.displayName = "SwitchBase";
export default SwitchBase;
